// JsFromRoutes CacheKey 86de3fc5712a4ced93390be5675aa38f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/help/domain'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/help/domain'),
  check: /* #__PURE__ */ definePathHelper('post', '/:account_id/help/domain/check'),
}
